var moment = require('moment');
var module = angular.module('octopusApp.infrastructure');

module.directive('inputDatePicker', function () {
    return {
        restrict: 'E',
        require: ['ngModel'],
        scope: {
            date: '=ngModel',
            minDate: '=',
            maxDate: '=',
            ngRequired: '=',
            dateOptions: '='
        },
        template: '<div class="input-group" style="width:175px">' +
        '<input type="text" ' +
        'class="form-control" ' +
        'placeholder="yyyy-MM-dd" ' +
        'ng-model="date" ' +
        'ng-required="ngRequired" ' +
        'datepicker-append-to-body="true" ' +
        'uib-datepicker-popup="yyyy-MM-dd" ' +
        'datepicker-options="datepickeroptions"' +
        'is-open="isOpen" ' +
        'on-open-focus="true"' +
        'close-text="Close" />' +
        ' <span class="input-group-btn">' +
        '<button type="button" class="btn btn-default popper" ng-click="open($event)"><i class="fa fa-calendar"></i></button></span>' +
        '</p>',
        replace: true,
        link: function ($scope, $element, $attributes) {
            $scope.isOpen = false;
            $scope.datepickeroptions = {
                dateDisabled: disabled,
                minDate: resolvedMinDate(),
                maxDate: resolvedMaxDate(),
                startingDay: 0
            };

            function resolveDate(date) {
                if ($scope.minDate === "today") {
                    return new Date();
                }
                return date;
            }

            function getDayStart(date) {
                if (date) {
                    return moment(resolveDate(date)).startOf("day");
                }
                return null;
            }

            function resolvedMinDate() {
                return getDayStart($scope.minDate).toDate();
            }

            function resolvedMaxDate() {
                return getDayStart($scope.maxDate).toDate();
            }

            function disabled(date, mode) {
                return (mode === 'day'
                    && ((date < resolvedMinDate())
                    || (date > resolvedMaxDate()))
                );
            }

            $scope.open = function ($event) {
                $event.preventDefault();
                $event.stopPropagation();

                $scope.isOpen = true;
            };
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/date_picker.js
// module id = 655
// module chunks = 1